import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcompanhamentoCasosRouboMainComponent } from './acompanhamento-casos-roubo-main/acompanhamento-casos-roubo-main.component';
import { GlobalModule } from 'src/app/global/global.module';

@NgModule({
  declarations: [AcompanhamentoCasosRouboMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class AcompanhamentoCasosRouboModule {}
